import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { ReporteIndividual } from "./ReporteIndividual/ReporteIndividual";
import { ReporteMensual } from "./ReporteMensual/ReporteMensual";
import "./styles/ReporteTraslados.css";

export class ReporteTraslados extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "REPORTE_INDIVIDUAL";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });

            sessionStorage.removeItem("traslados_reporte_individual_state");
            sessionStorage.removeItem("traslados_reporte_mensual_state");
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "93vw" }}>
                <Card
                    icon="traslados_activo"
                    titulo="REPORTE DE TRASLADOS"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}
                    >
                        <TabPane
                            tab="Reporte individual"
                            key="REPORTE_INDIVIDUAL"
                        >
                            <ReporteIndividual storageKey="traslados_reporte_individual_state" />
                        </TabPane>

                        <TabPane tab="Reporte mensual" key="REPORTE_MENSUAL">
                            <ReporteMensual storageKey="traslados_reporte_mensual_state" />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}
